import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';

const JotformExpertiseSection = () => {
  const { t } = useTranslation('jotform');

  const statsData = t('expertise.stats', { returnObjects: true });
  const stats = Array.isArray(statsData) ? statsData as Array<{
    number: string;
    label: string;
    description: string;
  }> : [];

  return (
    <section className="py-20 bg-muted/50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-bold">
                {t('expertise.title')}
              </h2>
              <h3 className="text-xl text-primary font-semibold">
                {t('expertise.subtitle')}
              </h3>
              <p className="text-lg text-muted-foreground leading-relaxed">
                {t('expertise.description')}
              </p>
            </div>
          </div>

          {/* Right Content - Stats Grid */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <Card key={index} className="text-center bg-background/80 backdrop-blur-sm border-primary/10 hover:border-primary/30 transition-colors">
                <CardContent className="p-6">
                  <div className="text-3xl font-bold text-primary mb-2">
                    {stat.number}
                  </div>
                  <div className="text-lg font-semibold text-foreground mb-2">
                    {stat.label}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {stat.description}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JotformExpertiseSection;